import { ApiClient } from '@/lib/axios/client';
import type {
  WatiSettings,
} from './types';

const BASE_PATH = '/v1/whatsapp';

export class WhatsappApi {
    static async getWatiSettings(): Promise<WatiSettings> {
        return await ApiClient.get<WatiSettings>(`${BASE_PATH}/settings`);
    }

    static async addWatiSettings(data: WatiSettings): Promise<WatiSettings> {
        return await ApiClient.post<WatiSettings>(`${BASE_PATH}/settings`, data);
    }
}
